import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatFormField, MatInputModule } from '@angular/material/input';
import { provideDateFnsDatetimeAdapter } from '@ng-matero/extensions-date-fns-adapter';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { ja } from 'date-fns/locale';

@Component({
  selector: 'app-datetime-range-picker',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormField,
    MtxDatetimepickerModule,
  ],
  providers: [
    {
      provide: MAT_DATE_LOCALE,
      useValue: ja,
    },
    provideDateFnsDatetimeAdapter({
      parse: {
        dateInput: 'yyyy/MM/dd',
        monthInput: 'MM',
        yearInput: 'yyyy',
        timeInput: 'HH:mm',
        datetimeInput: 'yyyy/MM/dd HH:mm',
      },
      display: {
        dateInput: 'yyyy/MM/dd',
        monthInput: 'MM',
        yearInput: 'yyyy',
        timeInput: 'HH:mm',
        datetimeInput: 'yyyy/MM/dd HH:mm',
        monthYearLabel: 'yyyy/MM',
        dateA11yLabel: 'yyyy/MM/dd',
        monthYearA11yLabel: 'yyyy/MM',
        popupHeaderDateLabel: 'yyyy/MM/dd',
      },
    }),
  ],
  templateUrl: './datetime-range-picker.component.html',
  styleUrl: './datetime-range-picker.component.scss',
})
export class DatetimeRangePickerComponent implements OnChanges {
  @Input({ required: true }) formGroup!: FormGroup;
  @Input({ required: true }) startFormControlName!: string;
  @Input({ required: true }) endFormControlName!: string;
  @Input() startFormLabel = '対象期間（開始）';
  @Input() endFormLabel = '対象期間（終了）';
  @Input() startErrorLabel = '開始日時';
  @Input() endErrorLabel = '終了日時';
  @Input() timeUnitLabel = '日時';
  @Input() maxRangeDays: number | undefined;
  @Input() maxRangeMonths: number | undefined;
  @Input() type: 'datetime' | 'date' = 'datetime';
  public placeholder = 'YYYY/MM/dd HH:mm';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['type'] !== undefined) {
      const pickerType = changes['type'].currentValue;
      const defaultPlaceholder =
        pickerType === 'date' ? 'YYYY/MM/dd' : 'YYYY/MM/dd HH:mm';
      this.placeholder = defaultPlaceholder;

      // typeが'date'のときにエラーメッセージを変更
      if (pickerType === 'date') {
        this.startErrorLabel = '開始日';
        this.endErrorLabel = '終了日';
        this.timeUnitLabel = '日';
      } else {
        // typeが'datetime'のときのデフォルトラベルを設定
        this.startErrorLabel = '開始日時';
        this.endErrorLabel = '終了日時';
        this.timeUnitLabel = '日時';
      }
    }
  }
}
